import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40879e68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "font-bold p-4" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Fetching clinical summary... ")
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold p-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hand-point-left mr-1" }),
  /*#__PURE__*/_createTextVNode(" Select an adjudication to view clinical summary ")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 3,
  class: "p-4"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle mr-1" }),
  /*#__PURE__*/_createTextVNode(" Unable to fetch clinical summary ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClinicalSummary = _resolveComponent("ClinicalSummary")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.state === 'LOADED')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_ClinicalSummary, { historical: _ctx.historical }, null, 8, ["historical"])
            ]))
          : (_ctx.state === 'FETCHING')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("p", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_Spinner, { class: "inline ml-1" })
                ])
              ]))
            : (_ctx.state === 'NULL')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : (_ctx.state === 'ERROR')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.retry && _ctx.retry(...args))),
                      class: "mt-4 cursor-pointer text-blue-900"
                    }, " Try again? ")
                  ]))
                : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}